import React from 'react';

function NoAccess() {
    return (
        <h3>No Access rights</h3>
    )

}

export default NoAccess;